import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import * as dayjs from 'dayjs';

@Component({
  selector: 'filter-time-range',
  templateUrl: './filter-time-range.component.html',
  styleUrls: ['./filter-time-range.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterTimeRangeComponent {

  @Input() set fromTime(v: string) {
    if(v) {
      const split = v.split(':');
      this._fromTime = new Date(0);
      this._fromTime.setHours(Number(split[0]));
      this._fromTime.setMinutes(Number(split[1]));
      this._fromLimit = this._fromTime;
    } else {
      this._fromTime = new Date(0);
      this._fromTime.setHours(0);
      this._fromTime.setMinutes(0);
      this._fromLimit = this._fromTime;
    }
  }

  @Input() set toTime(v: string) {
    if(v) {
      const split = v.split(':');
      this._toTime = new Date(0);
      this._toTime.setHours(Number(split[0]));
      this._toTime.setMinutes(Number(split[1]));
      this._toLimit = this._toTime;
    } else {
      this._toTime = new Date(0);
      this._toTime.setHours(23);
      this._toTime.setMinutes(59);
      this._toLimit = this._toTime;
    }
  }

  @Output() changeTimeRange: EventEmitter<{
    from_time: string;
    to_time: string;
  }> = new EventEmitter();

  public _fromTime: Date = new Date(0);
  public _toTime: Date = new Date(0);

  public _toLimit: Date;
  public _fromLimit: Date;

  public maxTime: Date = new Date(0);

  public minTime: Date = new Date(0);

  public formattedRange: string = '';
  public popoverOpen: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.minTime.setHours(0);
    this.minTime.setMinutes(0);
    this.maxTime.setHours(23);
    this.maxTime.setMinutes(59);
    this.formatRange();
  }

  public togglePopover() {
    this.popoverOpen = !this.popoverOpen;
  }

  public closePopover() {
    this.popoverOpen = false;
  }

  public formatRange(): void {
    this.formattedRange = `${String(this._fromTime.getHours()).padStart(2, '0')}:${String(this._fromTime.getMinutes()).padStart(2, '0')} - ${String(this._toTime.getHours()).padStart(2, '0')}:${String(this._toTime.getMinutes()).padStart(2, '0')}`;
  }

  public onChangeFromTime(fromTime): void {
    this._fromTime = fromTime;
    this._fromLimit = dayjs(fromTime).add(1, 'minute').toDate();
    this.formatRange();
    this.changeTimeRange.emit({
      from_time: `${String(this._fromTime.getHours()).padStart(2, '0')}:${String(this._fromTime.getMinutes()).padStart(2, '0')}`,
      to_time: `${String(this._toTime.getHours()).padStart(2, '0')}:${String(this._toTime.getMinutes()).padStart(2, '0')}`
    })
  }

  public onChangeToTime(toTime: Date): void {
    this._toTime = toTime;
    this._toLimit = dayjs(toTime).subtract(1, 'minute').toDate();
    this.formatRange();
    this.changeTimeRange.emit({
      from_time: `${String(this._fromTime.getHours()).padStart(2, '0')}:${String(this._fromTime.getMinutes()).padStart(2, '0')}`,
      to_time: `${String(toTime.getHours()).padStart(2, '0')}:${String(toTime.getMinutes()).padStart(2, '0')}`
    })
  }
}
